export const TASK_STATUS_OPTIONS = [
  { label: 'To Do',       value: 'to_do' },
  { label: 'In Progress', value: 'in_progress' },
  { label: 'Done',        value: 'done' },
  { label: 'Canceled',    value: 'canceled' },
];
